<template>
  <div id="serviceDom" class="x-service-wrapper flex-y-center flex-col">
    <!-- 引流图标 -->
    <div
      v-if="isChinese() && DIVERSION_MENU.length"
      class="online-service diversion-menu w-[48px]"
    >
      <div v-if="!showMenuAll" class="title text-white">联系我们</div>
      <div class="main" :class="{ expand: showMenuAll }">
        <div v-for="item in DIVERSION_MENU" :key="item.name">
          <component
            :is="item.name !== 'customer' ? Popover : 'div'"
            :placement="item.name !== 'code' ? 'left' : 'leftTop'"
            trigger="hover"
            @openChange="(visible: boolean) => onOpenChange(visible, item)"
            @click="onClick(item)"
          >
            <template #content>
              <div class="p-[14px] flex gap-[15px] cursor-pointer">
                <div
                  v-for="(detail, index) in item.child?.filter(
                    (item) => item.show
                  )"
                  :key="index"
                >
                  <div class="text-14 text-font-70 mb-[8px] text-center">
                    <div class="font-bold">
                      {{ detail?.tip1 }}
                    </div>
                  </div>
                  <div class="w-[198px] h-[198px]">
                    <Resource
                      class="w-full h-full"
                      :src="detail?.code"
                      :transform-resource="transformImage"
                    />
                  </div>
                  <div class="text-14 text-font-70 mt-[10px] text-center">
                    <div>{{ detail?.tip2 }}</div>
                  </div>
                </div>
              </div>
            </template>
            <div
              class="icon-wrapper px-[0px] text-center"
              :class="{
                '!cursor-default': !item.handle,
              }"
            >
              <iconpark-icon
                :name="item.icon"
                size="22"
                class="normal text-white"
              ></iconpark-icon>
              <div class="text-12 text-white scale-90 px-[4px]">
                {{ item.hover_name }}
              </div>
              <div
                v-if="item.hover_name1"
                class="text-12 text-white scale-90 px-[4px]"
              >
                {{ item.hover_name1 }}
              </div>
            </div>
          </component>
        </div>
      </div>
      <div class="toggle" @click="showMenuAll = !showMenuAll">
        <iconpark-icon
          name="arrowdown"
          class="text-white"
          :class="{
            'rotate-180': showMenuAll,
          }"
        ></iconpark-icon>
      </div>
    </div>
    <!-- 常规图标 -->
    <div v-if="showSub" class="online-service w-[48px]">
      <div v-if="!showAll" class="title text-font-70">了解更多</div>
      <div class="main" :class="{ expand: showAll }">
        <template v-for="item in SERVICE_CONTENT" :key="item.name">
          <a-popover
            v-if="!showPopTip ? true : item.name !== 'help'"
            :placement="item.name !== 'code' ? 'left' : 'leftTop'"
          >
            <template #content>
              <template v-if="item.child">
                <div
                  v-for="detail in item.child.filter((item) => item.show)"
                  :key="detail.text"
                  class="text-font-1 hover:text-primary cursor-pointer py-[5px]"
                  @click="onClick(detail)"
                >
                  {{ detail.text }}
                </div>
              </template>
              <template v-else-if="item.name !== 'code' && !item.child">
                {{ item.hover_name }}
              </template>
            </template>
            <div class="icon-wrapper" @click="onClick(item)">
              <iconpark-icon
                :name="item.icon"
                size="22"
                class="normal text-font-1"
              ></iconpark-icon>
            </div>
          </a-popover>
          <a-popover
            v-else-if="item.name === 'help' && showPopTip"
            placement="left"
            :open="true"
          >
            <template #content>
              {{ item.hover_name }}
            </template>
            <div class="icon-wrapper" @click="onClick(item)">
              <iconpark-icon :name="item.icon" size="22"></iconpark-icon>
            </div>
          </a-popover>
        </template>
      </div>
      <div class="toggle" @click="showAll = !showAll">
        <iconpark-icon
          name="arrowdown"
          class="text-font-70"
          :class="{
            'rotate-180': showAll,
          }"
        ></iconpark-icon>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Popover } from 'ant-design-vue'
import { UPDATE_PROJECT_SHOW } from '~/constants/config'
import { B_SIDE_QRCODE, C_SIDE_QRCODE, MARKDOWN_NAME } from '~/constants/index'
import { PageKey } from '~/constants/page'
import { showContact } from '~/hooks/useModal/modals/contact'
import { showFeedback } from '~/hooks/useModal/modals/feedback'

const router = useRouter()
const { $t } = useNuxtApp()
const showPopTip = ref(false)
const showAll = ref(true)
const showMenuAll = ref(true)
type Item = {
  hover_name: string
  hover_name1?: string
  text?: string
  name: string
  icon: string
  trackEvent?: TRACK_EVENT
  handle?: () => void
  child?: {
    text?: string
    trackEvent?: TRACK_EVENT
    handle?: () => void
    code?: string
    tip1?: string
    tip2?: string
    show: boolean
  }[]
  content?: {
    code: string
    tip1?: string
    tip2?: string
  }
  hasContent?: boolean
  show: boolean
}

const { hasActionPermission, hasPagePermission } =
  usePageAndActionPermissionData()

// 引流图标
const DIVERSION_MENU = computed<Item[]>(() =>
  [
    {
      hover_name: '微信咨询',
      name: 'wechat',
      icon: 'float-wechat',
      trackEvent: TRACK_EVENT.CLICK_SUSPENDED_WECHAT,
      child: [
        {
          code: B_SIDE_QRCODE,
          tip1: '企业需求咨询',
          tip2: '扫码加行业专家·快速响应',
          show: true,
        },
        {
          code: C_SIDE_QRCODE,
          tip1: '个人需求咨询',
          tip2: '扫码领取新手速成5节课',
          show: true,
        },
      ],
      show: hasActionPermission('wechat_consult'),
    },
    {
      hover_name: '预约演示',
      name: 'yanshi',
      icon: 'float-yanshi',
      trackEvent: TRACK_EVENT.CLICK_SUSPENDED_YANSHI,
      child: [
        {
          // code: getFeUrl('/youyan-platform/png/qrcode/yanshi-qrcode.png'),
          code: B_SIDE_QRCODE,
          tip1: '预约产品功能演示',
          tip2: '扫码额外赠·行业应用案例',
          show: true,
        },
      ],
      show: hasActionPermission('book_demonstration'),
    },
    {
      hover_name: 'AI',
      hover_name1: '干货',
      name: 'crate',
      icon: 'float-create',
      child: [
        {
          // code: getFeUrl('/youyan-platform/png/qrcode/AI-qrcode1.png'),
          code: C_SIDE_QRCODE,
          tip1: 'AIGC训练营·5天速成',
          tip2: '扫码立即入营',
          show: hasActionPermission('industry_app_cases'),
        },
        {
          // code: getFeUrl('/youyan-platform/png/qrcode/AI-qrcode2.png'),
          code: B_SIDE_QRCODE,
          tip1: '行业趋势报告&实操直播课',
          tip2: '扫码领取企业干货',
          show: hasActionPermission('creative_camp_qr_code'),
        },
      ],
      trackEvent: TRACK_EVENT.CLICK_SUSPENDED_AI_CAMP,
      show:
        hasActionPermission('industry_app_cases') ||
        hasActionPermission('creative_camp_qr_code'),
    },
    {
      hover_name: '在线客服',
      name: 'customer',
      icon: 'float-customer',
      trackEvent: TRACK_EVENT.CLICK_SUSPENDED_CONTACT_CUSTOMER_SERVICE,
      handle: () => openCustomerService(),
      hasContent: false,
      show: hasActionPermission('human_customer_service'),
    },
  ].filter((item) => item.show)
)

// 正常显示图标
const SERVICE_CONTENT = computed<Item[]>(() =>
  [
    {
      hover_name: $t('bang-zhu-zhong-xin'),
      text: $t('chan-pin-geng-xin-ri-zhi-ke-yi-zai-ci-chu-cha-kan'),
      name: 'help',
      icon: 'float-help',
      hasContent: false,
      trackEvent: TRACK_EVENT.CLICK_SUSPENDED_HELP_CENTER,
      handle: () =>
        router.push({
          name: PageKey.HELP_CENTER,
          params: { id: MARKDOWN_NAME.HELP_CENTER },
        }),
      show: hasPagePermission(PageKey.HELP_CENTER),
      // child: [
      //   {
      //     text: $t('bang-zhu-zhong-xin'),
      //     trackEvent: TRACK_EVENT.CLICK_SUSPENDED_HELP_CENTER,
      //     handle: () =>
      //       router.push({
      //         name: PageKey.HELP_CENTER,
      //         params: { id: MARKDOWN_NAME.HELP_CENTER },
      //       }),
      //     show: hasPagePermission(PageKey.HELP_CENTER),
      //   },
      //   {
      //     text: $t('chan-pin-geng-xin-wen-dang'),
      //     trackEvent: TRACK_EVENT.CLICK_SUSPENDED_HELP_CENTER,
      //     handle: () =>
      //       router.push({
      //         name: PageKey.HELP_CENTER,
      //         params: { id: MARKDOWN_NAME.PROJECT_UPDATE },
      //       }),
      //     show: hasActionPermission('product_update_doc'),
      //   },
      // ],
      // show:
      //   hasPagePermission(PageKey.HELP_CENTER) ||
      //   hasActionPermission('product_update_doc'),
    },
    {
      hover_name: '意见反馈',
      name: 'email',
      icon: 'float-email',
      trackEvent: TRACK_EVENT.CLICK_SUSPENDED_FEEDBACK,
      handle: () => showFeedback(),
      hasContent: false,
      show: hasActionPermission('feedback_portal'),
    },
  ].filter((item) => item.show)
)

const route = useRoute()

const showSub = computed(() => {
  return (
    isChinese() &&
    SERVICE_CONTENT.value.length &&
    ![PageKey.LANDING, PageKey.SUYING, PageKey.BRAND].includes(
      route.name as PageKey
    )
  )
})

function onClick(item: Item) {
  if (item.trackEvent) {
    trackEvent(item.trackEvent)
  }

  item.handle?.()
}

function contactUs() {
  trackEvent(TRACK_EVENT.CLICK_SUSPENDED_CONTACT_US)
  showContact()
}

onMounted(() => {
  emitter.on(EVENT.UPDATE_PROJECT_TIP, () => {
    showPopTip.value = true
    localSetItem(UPDATE_PROJECT_SHOW, 1)
    setTimeout(() => {
      showPopTip.value = false
    }, 1000 * 3)
  })
})

const onOpenChange = (visible: boolean, item: Item) => {
  if (item.trackEvent && visible) {
    trackEvent(item.trackEvent)
    // item.handle?.()
  }
}
</script>

<style lang="scss" scoped>
.x-service-wrapper {
  @apply text-font-1;
}
.online-service {
  @apply rounded-[8px] backdrop-blur-[3px] p-[6px_4px] flex-y-center flex-col z-20 gap-[6px]  overflow-y-hidden;
  background: var(--customer-service-bg);
  box-shadow: 0px 2px 19px 1px rgba(0, 0, 0, 0.1);
  .title {
    @apply text-12 px-[8px] mt-[2px] -mb-[6px];
  }
  .icon-wrapper {
    @apply w-[40px] h-[40px] flex-y-center justify-center cursor-pointer;
    &:hover {
      background: var(--back-3);
      border-radius: 6px;
    }
  }
  .toggle {
    @apply cursor-pointer w-[40px] h-[22px] flex-y-center text-center rounded-[6px] justify-center;
    &:hover {
      @apply bg-back-3;
    }
  }
  .main {
    @apply max-h-[0] invisible;
    transform-origin: 50% 0;
    overflow: hidden;
  }
  .expand {
    @apply visible;
    transition: all 0.6s;
    max-height: 280px;
  }
}
.diversion-menu {
  @apply mb-[12px];
  background: var(--purple-6);
  .icon-wrapper {
    @apply h-[70px] block;
    padding-top: 6px;
    &:hover {
      background: var(--purple-5);
    }
  }
  .toggle {
    &:hover {
      @apply bg-purple-5;
    }
  }
}
</style>
